import { BusinessTechnicalSolution, SectionTitle } from '@/ui/index';

import styles from './TechnicalSolutions.module.scss';

const TechnicalSolutions = ({ data }) => {
  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/Service'
    >
      <SectionTitle titleModify={'title--large'}>{data?.title}</SectionTitle>
      {data?.sections && (
        <div className={styles.grid}>
          {data.sections.map((item, index) => (
            <BusinessTechnicalSolution data={item} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TechnicalSolutions;
